import { NUMBER } from "../../../constants/app-constants";
import { DEFAULT_SETTLED_CHALLAN_COUNT } from "../../../constants/challan-constants";

export const TITLE_MAPPING = {
    [NUMBER.ZERO]: {
        title: "We are getting the challan details for your vehicle",
        description: ""
    },
    [NUMBER.ONE]: {
        title: `${DEFAULT_SETTLED_CHALLAN_COUNT} users have successfully paid their challans with CARS24`,
        description: ""
    },
    [NUMBER.TWO]: {
        title: "CARS24 makes it easy to find and pay challans",
        description: ""
    }
};
